import { User } from "../domain/domain";

export type UserState = {
    currentUser: User | undefined
}

const initialState: UserState = {
    currentUser: undefined
}

export enum UserActionType {
    USER_LOADED = "USER_LOADED",
    USER_LOGOUT = "USER_LOGOUT"
}

export interface UserLoaded {
    type: UserActionType.USER_LOADED,
    user: User
}


export interface UserLogout {
    type: UserActionType.USER_LOGOUT
}

export type UserActions = UserLoaded | UserLogout

export function userReducer(
    state = initialState,
    action: UserActions
    ): UserState {
        switch (action.type) {
            case UserActionType.USER_LOADED:
                return {
                    ...state,
                    currentUser: action.user
                }
            case UserActionType.USER_LOGOUT:
                return {
                    ...state,
                    currentUser: undefined
                }
            default:
                return state;
        }
    }